'use strict';

exports.__esModule = true;
exports.setDefaultLanguage = exports.getDefaultLanguage = exports.languages = exports.locales = undefined;

var _english = require('../styles/images/english.png');

var _english2 = _interopRequireDefault(_english);

var _germany = require('../styles/images/germany.png');

var _germany2 = _interopRequireDefault(_germany);

var _enGB = require('date-fns/locale/en-GB');

var _enGB2 = _interopRequireDefault(_enGB);

var _de = require('date-fns/locale/de');

var _de2 = _interopRequireDefault(_de);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locales = exports.locales = {
  en: _enGB2.default,
  de: _de2.default
};

// The order matters! The order MUST follow the order of server return translation.
var languages = exports.languages = [{ name: 'English', code: 'en', flag: _english2.default }, { name: 'Deutsch', code: 'de', flag: _germany2.default }];

var getDefaultLanguage = exports.getDefaultLanguage = function getDefaultLanguage() {
  return (
    // Deutsches Schulprodukt: DE ist der Default fuer neue Besucher, unabhaengig von
    // der Browser-Sprache (ein englischer Browser bekam bisher EN). Die manuelle
    // Wahl im Language-Switcher wird ueber localStorage weiterhin respektiert.
    localStorage.getItem('languageCode') || 'de'
  );
};

var setDefaultLanguage = exports.setDefaultLanguage = function setDefaultLanguage(code) {
  localStorage.setItem('languageCode', code);
};